import { Module } from '../Module';
import { _tab } from './functions/_tab';

export class Tabs extends Module {
	initialize() {
		_tab();
	}
}
